'use client';
import styled from 'styled-components';

export const Caption = styled.p`
  margin: ${props => props.theme.spacing(3, 0)};
  ${props => props.theme.typography.body}
`;

export const StyledQuestion = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(3)};
  margin-bottom: 0;
  text-align: center;
  width: 100%;
  background-color: ${props =>
    props.$bgColor && props.theme.colors.get(props.$bgColor)};
  padding: ${props => props.theme.spacing(0, 5, 5, 5)};
  border-radius: 32px;
  h2 {
    ${props => props.theme.fontFamily.base}
    margin-bottom: ${props => props.theme.spacing(5)};
  }
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  margin: ${props => props.theme.spacing(1, 0)};
`;
